<mat-icon
  class="info-tooltip"
  [class.info-tooltip--inline]="inline"
  [matTooltip]="tooltip"
  aria-hidden="false"
  aria-label="Info"
  svgIcon="questionmark"
></mat-icon>
